import axiosInstance from "../interceptor/interceptor";
import applicationDetailsDictionary from "../dictionary/applicationDetailsDictionary";

const applicationDetailsServices = {
  getApplicationLoanDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(
      applicationDetailsDictionary.getApplicationLoanDetails(),
      { applicantId, trackingId }
    ),
  getAcademicDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getAcademicDetails(), {
      applicationId,
      trackingId,
    }),
  getEmploymentDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getEmploymentDetails(), {
      applicantId,
      trackingId,
    }),
  getEntranceDetails: (
    applicationId: string,
    applicantId: string,
    trackingId: string
  ) =>
    axiosInstance.post(applicationDetailsDictionary.getEntranceDetails(), {
      applicationId,
      applicantId,
      trackingId,
    }),
  getLoanDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getLoanDetails(), {
      applicantId,
      trackingId,
    }),
  getExpenseDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getExpenseDetails(), {
      applicationId,
      trackingId,
    }),
  getReferenceDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getReferenceDetails(), {
      applicationId,
      trackingId,
    }),
  getCoApplicantDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getCoApplicantDetails(), {
      applicationId,
      trackingId,
    }),
  getCoApplicantCompletionRate: (trackingId: string) =>
    axiosInstance.post(
      applicationDetailsDictionary.getCoApplicantCompletionRate(),
      {
        trackingId,
      }
    ),
  getCollateralDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getCollateralDetails(), {
      applicationId,
      trackingId,
    }),

  getCoApplicantBasicDetails: (applicantId: string, trackingId: string) =>
      axiosInstance.post(
        applicationDetailsDictionary.getCoApplicantBasicDetails(),
        { applicantId, trackingId },
      ),
  getLoanDetailsFromProcessio: (trackingId: string) =>
    axiosInstance.get(
      applicationDetailsDictionary.getLoanDetailsFromProcessio(trackingId),
    ),

  updateShowCustomerDataFlag: (payload: { trackingId: string, showCustomerData: boolean }) =>
    axiosInstance.post(
      applicationDetailsDictionary.updateShowCustomerDataFlagApiUrl(),
      payload
    ),
};

export default applicationDetailsServices;
